export const GET_PRODUCER				  = 'GET_PRODUCER'
export const GET_PRODUCER_SUCCESS = 'GET_PRODUCER_SUCCESS'
export const GET_PRODUCER_FAIL		= 'GET_PRODUCER_FAIL'